// extracted by mini-css-extract-plugin
module.exports = {"EditoCenteredText":"styles_EditoCenteredText__qHkLJ","grid":"styles_grid__3Y168","title":"styles_title__3ibwf","text":"styles_text__3i0AW"};